import { cn, PaletteUtils } from '@shared/utils';
import { Text } from '@shared/widgets';

interface SidebarRowProps {
  className?: string;
  isHidden?: boolean;
  label: string;
  value?: string;
}

export const SidebarRow = (props: SidebarRowProps) => {
  if (props.isHidden) return null;
  return (
    <div className={cn('mb-5 flex justify-between gap-2', props.className)}>
      <Text color={PaletteUtils.isVcfcPalette ? 'gray' : undefined} size='sm'>
        {props.label}
      </Text>
      {props.value && (
        <Text className='pl-1' weight='medium' size='sm' truncate>
          {props.value}
        </Text>
      )}
    </div>
  );
};
